import { render, staticRenderFns } from "./EditProducts.vue?vue&type=template&id=a4e396d2"
import script from "./EditProducts.vue?vue&type=script&lang=js"
export * from "./EditProducts.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EditProducts.vue?vue&type=style&index=1&id=a4e396d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports